import { useState } from "react";
import CheckBox from "../../front-end-global-components/components/CheckBox/CheckBox";
import Modal from "../../front-end-global-components/components/Modal/Modal";

const termsList = [
  {
    id: "aadhaar_consent",
    text: `I am voluntarily sharing my Aadhaar Number / Virtual ID issued by the Unique Identification Authority of India (“UIDAI”), and my demographic information for the purpose of creating an Ayushman Bharat Health Account number (“ABHA number”) and Ayushman Bharat Health Account address (“ABHA Address”). I authorize Ninto to use my Aadhaar number / Virtual ID for performing Aadhaar based authentication with UIDAI as per the provisions of the Aadhaar (Targeted Delivery of Financial and other Subsidies, Benefits and Services) Act, 2016 for the aforesaid purpose. I understand that UIDAI will share my e-KYC details, or response of “Yes” with Ninto upon successful authentication`
  },
  {
    id: "linking_records",
    text: `I consent to usage of my ABHA address and ABHA number for linking of my legacy (past) health records and those which will be generated during this encounter.`
  },
  {
    id: "share_records",
    text: `I authorize the sharing of all my health records with healthcare provider(s) for the purpose of providing healthcare services to me during this encounter.`
  },
  {
    id: "anonymization",
    text: `I consent to the anonymization and subsequent use of my health records for public health purposes.`
  },
  {
    id: "worker_confirmation",
    text: `I, confirm that I have duly informed and explained the beneficiary of the contents of consent for aforementioned purposes.`
  },
  {
    id: "beneficiary_confirmation",
    text: `I, have been explained about the consent as stated above and hereby provide my consent for the aforementioned purposes.`
  }
];

const AadhaarTerms = () => {
  return (
    <div
      className="font-family-gilroy font-size-small font-color-secondary padding-medium "
      style={{ lineHeight: "20px", textAlign: "justify" }}
    >
      I, hereby declare that I am voluntarily sharing my Aadhaar Number and
      demographic information issued by UIDAI, with National Health Authority
      (NHA) for the sole purpose of creation of ABHA number. I understand that
      my ABHA number can be used and shared for purposes as may be notified by
      ABDM from time to time including provision of healthcare services.
      Further, I am aware that my personal identifiable information (Name,
      Address, Age, Date of Birth, Gender and Photograph) may be made available
      to the entities working in the National Digital Health Ecosystem (NDHE)
      which inter alia includes stakeholders and entities.
    </div>
  );
};

const CreationTerms = () => {
  return (
    <div
      className="font-family-gilroy font-size-small font-color-secondary padding-medium "
      style={{ lineHeight: "20px", textAlign: "justify" }}
    >
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp; I, hereby declare that I am voluntarily sharing
        my identity information with Ninto for the sole purpose of creation of
        Ayushman Bharat Health Account (ABHA) Address. I consciously choose to
        share my personal information (Name, Address, Date of Birth and Gender)
        for the creation of ABHA Address. I understand that my personal
        identifiable information, relevant to this transaction, will be stored
        by Ninto solely for the purpose of creation of ABHA Address.
      </p>
      <p className="padding-top-default">
        I am aware that my personal identifiable information (Name, Address,
        Date of Birth and Gender) may be made available to the entities
        participating in the Ayushman Bharat Digital Mission (ABDM) ecosystem
        for enabling the healthcare services to me across India. I understand
        that my ABHA Number & ABHA Address can be used in any healthcare
        interaction across India. I reserve the right to revoke the given
        consent to Ninto at any time at my own discretion.
      </p>
    </div>
  );
};

export default function TermsAndConditionModal(props) {
  const [checkList, setCheckList] = useState({});

  const changeCheckList = (checked, id) => {
    setCheckList((prev) => ({
      ...prev,
      [id]: checked
    }));
  };

  return (
    <Modal
      show={true}
      onClose={() => props.onClose()}
      canIgnore={true}
      position="position-fixed bottom-0 left-0 right-0"
      boxShadow="none"
      borderRadius="none"
      width="inherit-parent-width"
      background="background-transparent"
    >
      <div className="background-white padding-default font-family-gilroy-medium user-select-none">
        <div className="inherit-parent-width inherit-parent-height padding-bottom-large">
          <div className="text-align-center font-size-small padding-medium font-color-secondary">
            TERMS AND CONDITION
          </div>
          <div
            style={{ height: "280px" }}
            className="hide-scroll-bar overflow-auto"
          >
            {props.isAadhaarTerms ? <AadhaarTerms /> : <></>}
            {props.isCreationTerms ? <CreationTerms /> : <></>}

            {!props.isAadhaarTerms && !props.isCreationTerms && (
              <div className="font-size-small font-color-secondary padding-bottom-default padding-left-small">
                I, hereby declare that
              </div>
            )}

            {!props.isAadhaarTerms &&
              !props.isCreationTerms &&
              termsList.map((data) => (
                <div
                  key={data.id}
                  className="padding-bottom-larger padding-left-default padding-right-default"
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "10px"
                  }}
                >
                  <CheckBox
                    name={data.id}
                    id={data.id}
                    checked={!!checkList[data.id]}
                    onChange={(event) =>
                      changeCheckList(event.target.checked, data.id)
                    }
                  />

                  <p
                    style={{ lineHeight: "20px", textAlign: "justify" }}
                    className="font-size-small font-color-secondary"
                  >
                    {data.text}
                  </p>
                </div>
              ))}
          </div>
        </div>
      </div>
    </Modal>
  );
}
